function itemClickEvent() {
  $(".product_box").on("click", " ul.color_list li input", function(){
      $(".product_box").removeClass("active_product");
      $(this).parents(".product_box").addClass("active_product");
      var radioValue = $(".product_box.active_product ul.color_list li input:checked+label").attr("data-value");
      if(radioValue){
         $(".product_box.active_product .product_img img").attr("src", radioValue); 
      }
  });
var max = 3;
$('.product_box ul.color_list').each(function(){
  $(this).find('li').each(function(index){
    if(index >= max) $(this).hide()
  })
})
}
$(document).ready(function() {
    itemClickEvent();
})


